// extracted by extract-css-chunks-webpack-plugin
module.exports = {"dropdownLinks":"_1eAVJj","item":"_3BLGyV","itemLink":"_1kVzvq"};